import { render, staticRenderFns } from "./Agentscb.vue?vue&type=template&id=2490a324"
import script from "./Agentscb.vue?vue&type=script&lang=js"
export * from "./Agentscb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports